import React from 'react';
import { Button, Icon, Modal } from 'lmc-ui-library';
import { ErrorItem, ErrorText } from '../../pages/CaseDetailsPage/subPages/Credit/CreditComponent.styled';

const getErrorsFromError = (error: any): string[] => {
  let errors: any = [];

  if (!error) {
    return [];
  }

  const conflictErrorMessage =
    'Changes have been made by someone else since you started editing. Please exit the case without saving, then make your changes again.';

  if (error.response) {
    errors = [...errors, `An unexpected error occurred (${error.response.status})`];
    if (error.response.status === 409) {
      errors = [...errors, conflictErrorMessage];
    }
    if (error.response.data.errors && Array.isArray(error.response.data.errors)) {
      errors = [...errors, ...error.response.data.errors];
    } else if (error.response.data.details) {
      const message =
        error.response.data.errorCode === 'COMPLEX' && error.response.data.details.detail
          ? error.response.data.details.detail.toString()
          : error.response.data.details.toString();
      errors = [...errors, message];
    }
  } else {
    errors = [error.toString()];
  }
  return errors;
};

const ErrorModal: React.FC<any> = ({ error, onCloseButtonClick }) => {
  return (
    <Modal showCloseBtn={false} isOpen={error}>
      <Modal.Header title="Error!" mode="error" />
      <Modal.Content>
        {getErrorsFromError(error).map((err, index) => (
          <ErrorItem key={index}>
            <Icon type="warning" color="#FA5245" />
            <ErrorText>{err}</ErrorText>
          </ErrorItem>
        ))}
      </Modal.Content>
      <Modal.Footer style={{ display: 'grid' }}>
        <Button mode="ghost" borderVariant="rectangle" onClick={onCloseButtonClick}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ErrorModal;
